import { createAction } from 'redux-actions';
import { authFetch } from '../AuthFetch';

export const changeGearSpecValue = createAction('CHANGE_GEARSPEC_VALUE');

export const findGearSpecList = (pagingData, serachData) => (
  (dispatch) => {
    let searchDataUrl = '';
    if (serachData != null) {
      searchDataUrl = '&searchKeys=';
      for (let i = 0; i < serachData.searchKeys.length; i++) {
        searchDataUrl += serachData.searchKeys[i] + ',';
      }
      searchDataUrl += '&searchWord=' + serachData.searchWord;
    }

    let url = '/firefighter/gearSpecs?activePage=' + pagingData.activePage + '&itemPerPage=' + pagingData.itemPerPage + searchDataUrl;
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'FIND_GEARSPEC_LIST',
        payload: json
      });
    });
  }
);

export const addGearSpec = (gearSpec, pagingData) => (
  (dispatch) => {
    let url = '/firefighter/gearSpecs';
    authFetch('POST', url, JSON.stringify(gearSpec), (json) => {
      dispatch({
        type: 'FORM_SUBMIT_GEARSPEC',
        payload: json
      });
      dispatch(findGearSpecList(pagingData));
    });
  }
);

export const editGearSpec = (gearSpec, pagingData) => (
  (dispatch) => {
    let url = '/firefighter/gearSpecs/' + gearSpec.get('specId');
    authFetch('PUT', url, JSON.stringify(gearSpec), (json) => {
      dispatch({
        type: 'FORM_SUBMIT_GEARSPEC',
        payload: json
      });
      dispatch(findGearSpecList(pagingData));
    });
  }
);

export const deleteGearSpec = (deleteKey, pagingData) => (
  (dispatch) => {
    let url = '/firefighter/gearSpecs';
    authFetch('DELETE', url, JSON.stringify(deleteKey), (json) => {
      dispatch({
        type: 'DELETE_GEARSPEC',
        payload: json
      });
      dispatch(findGearSpecList(pagingData));
    });
  }
);

export const findGearSpec = (pk) => (
  (dispatch) => {
    let url = '/firefighter/gearSpecs/' + pk.spec_id;
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'FIND_GEARSPEC',
        payload: json
      });
    });
  }
);

export const findGearSpecIdsByGearName = (pk) => (
  (dispatch) => {
    let url = '/firefighter/gearSpecs/gearName/' + pk.gear_name;
    authFetch('GET', url, null, (json) => {
      dispatch({
        type: 'FIND_GEARSPEC_IDS',
        payload: json
      });
    });
  }
);

export const changeGearSpecActivePage = createAction('CHANGE_GEARSPEC_ACTIVE_PAGE');
export const openGearSpecModal = createAction('OPEN_GEARSPEC_MODAL');
export const closeGearSpecModal = createAction('CLOSE_GEARSPEC_MODAL');


// WEBPACK FOOTER //
// ./src/actions/gearSpecActions.js